export const hypertrophyWorkouts = {
  "chest-back": {
    title: "Workout 1: Chest and Back",
    shortTitle: "Chest and Back",
    description:
      "Agonist–antagonist supersets, PR first—then lengthened partials—to grow chest, back, and shoulders fast.",
    videoId: "be758ee20b6c365e78cedd166c443057",
    thumbnailTimestampSeconds: 1,
    transcriptPath: "/transcripts/hypertrophy/chest-back.md",
  },
  "arms-smaller-muscles": {
    title: "Workout 2: Arms and Smaller Muscles",
    shortTitle: "Arms and Smaller Muscles",
    description:
      "Agonist–antagonist arm pairing to keep capacity high—lengthened-range work for size, capped by seated calf raises that hammer calves in the bottom range for maximal growth.",
    videoId: "1d6785bb61da86fec74b355f36edc8b6",
    thumbnailTimestampSeconds: 2.5,
    transcriptPath: "/transcripts/hypertrophy/arms-smaller-muscles.md",
  },
  "legs-lower-back": {
    title: "Workout 3: Legs and Lower Back",
    shortTitle: "Legs and Lower Back",
    description:
      "Single-leg strength, then lengthened-range squats paired with hamstring-biased deadlifts—finish with forearms for complete lower-body + grip development.",
    videoId: "2902b3c65c95d654e6f6bb97faa5ce88",
    thumbnailTimestampSeconds: 1,
    transcriptPath: "/transcripts/hypertrophy/legs-lower-back.md",
  },
};

export const hypertrophyIntro = {
  title: "Introduction to the X3 Hypertrophy Program",
  pageTitle: "X3 Hypertrophy Program: Build Maximum Muscle",
  subtitle:
    "Dr. Jaquish’s advanced training plan, developed with Matt Wenning, to help you achieve peak hypertrophy.",
  videoId: "743af1c3411e6610ceae0e0cf24ea538",
  thumbnailTimestampSeconds: 2.5,
  transcriptPath: "/transcripts/hypertrophy/intro.md",
};
